"use strict";

/////////////////////////////////
////////////// MD5 /////////////
///////////////////////////////
function md5(inputString) {
    var hc="0123456789abcdef";
    function rh(n) {var j,s="";for(j=0;j<=3;j++) s+=hc.charAt((n>>(j*8+4))&0x0F)+hc.charAt((n>>(j*8))&0x0F);return s;}
    function ad(x,y) {var l=(x&0xFFFF)+(y&0xFFFF);var m=(x>>16)+(y>>16)+(l>>16);return (m<<16)|(l&0xFFFF);}
    function rl(n,c)            {return (n<<c)|(n>>>(32-c));}
    function cm(q,a,b,x,s,t)    {return ad(rl(ad(ad(a,q),ad(x,t)),s),b);}
    function ff(a,b,c,d,x,s,t)  {return cm((b&c)|((~b)&d),a,b,x,s,t);}
    function gg(a,b,c,d,x,s,t)  {return cm((b&d)|(c&(~d)),a,b,x,s,t);}
    function hh(a,b,c,d,x,s,t)  {return cm(b^c^d,a,b,x,s,t);}
    function ii(a,b,c,d,x,s,t)  {return cm(c^(b|(~d)),a,b,x,s,t);}
    function sb(x) {
        var i;var nblk=((x.length+8)>>6)+1;var blks=new Array(nblk*16);for(i=0;i<nblk*16;i++) blks[i]=0;
        for(i=0;i<x.length;i++) blks[i>>2]|=x.charCodeAt(i)<<((i%4)*8);
        blks[i>>2]|=0x80<<((i%4)*8);blks[nblk*16-2]=x.length*8;return blks;
    }
    var i,x=sb(inputString),a=1732584193,b=-271733879,c=-1732584194,d=271733878,olda,oldb,oldc,oldd;
    for(i=0;i<x.length;i+=16) {olda=a;oldb=b;oldc=c;oldd=d;
        a=ff(a,b,c,d,x[i+ 0], 7, -680876936);d=ff(d,a,b,c,x[i+ 1],12, -389564586);c=ff(c,d,a,b,x[i+ 2],17,  606105819);
        b=ff(b,c,d,a,x[i+ 3],22,-1044525330);a=ff(a,b,c,d,x[i+ 4], 7, -176418897);d=ff(d,a,b,c,x[i+ 5],12, 1200080426);
        c=ff(c,d,a,b,x[i+ 6],17,-1473231341);b=ff(b,c,d,a,x[i+ 7],22,  -45705983);a=ff(a,b,c,d,x[i+ 8], 7, 1770035416);
        d=ff(d,a,b,c,x[i+ 9],12,-1958414417);c=ff(c,d,a,b,x[i+10],17,     -42063);b=ff(b,c,d,a,x[i+11],22,-1990404162);
        a=ff(a,b,c,d,x[i+12], 7, 1804603682);d=ff(d,a,b,c,x[i+13],12,  -40341101);c=ff(c,d,a,b,x[i+14],17,-1502002290);
        b=ff(b,c,d,a,x[i+15],22, 1236535329);a=gg(a,b,c,d,x[i+ 1], 5, -165796510);d=gg(d,a,b,c,x[i+ 6], 9,-1069501632);
        c=gg(c,d,a,b,x[i+11],14,  643717713);b=gg(b,c,d,a,x[i+ 0],20, -373897302);a=gg(a,b,c,d,x[i+ 5], 5, -701558691);
        d=gg(d,a,b,c,x[i+10], 9,   38016083);c=gg(c,d,a,b,x[i+15],14, -660478335);b=gg(b,c,d,a,x[i+ 4],20, -405537848);
        a=gg(a,b,c,d,x[i+ 9], 5,  568446438);d=gg(d,a,b,c,x[i+14], 9,-1019803690);c=gg(c,d,a,b,x[i+ 3],14, -187363961);
        b=gg(b,c,d,a,x[i+ 8],20, 1163531501);a=gg(a,b,c,d,x[i+13], 5,-1444681467);d=gg(d,a,b,c,x[i+ 2], 9,  -51403784);
        c=gg(c,d,a,b,x[i+ 7],14, 1735328473);b=gg(b,c,d,a,x[i+12],20,-1926607734);a=hh(a,b,c,d,x[i+ 5], 4,    -378558);
        d=hh(d,a,b,c,x[i+ 8],11,-2022574463);c=hh(c,d,a,b,x[i+11],16, 1839030562);b=hh(b,c,d,a,x[i+14],23,  -35309556);
        a=hh(a,b,c,d,x[i+ 1], 4,-1530992060);d=hh(d,a,b,c,x[i+ 4],11, 1272893353);c=hh(c,d,a,b,x[i+ 7],16, -155497632);
        b=hh(b,c,d,a,x[i+10],23,-1094730640);a=hh(a,b,c,d,x[i+13], 4,  681279174);d=hh(d,a,b,c,x[i+ 0],11, -358537222);
        c=hh(c,d,a,b,x[i+ 3],16, -722521979);b=hh(b,c,d,a,x[i+ 6],23,   76029189);a=hh(a,b,c,d,x[i+ 9], 4, -640364487);
        d=hh(d,a,b,c,x[i+12],11, -421815835);c=hh(c,d,a,b,x[i+15],16,  530742520);b=hh(b,c,d,a,x[i+ 2],23, -995338651);
        a=ii(a,b,c,d,x[i+ 0], 6, -198630844);d=ii(d,a,b,c,x[i+ 7],10, 1126891415);c=ii(c,d,a,b,x[i+14],15,-1416354905);
        b=ii(b,c,d,a,x[i+ 5],21,  -57434055);a=ii(a,b,c,d,x[i+12], 6, 1700485571);d=ii(d,a,b,c,x[i+ 3],10,-1894986606);
        c=ii(c,d,a,b,x[i+10],15,   -1051523);b=ii(b,c,d,a,x[i+ 1],21,-2054922799);a=ii(a,b,c,d,x[i+ 8], 6, 1873313359);
        d=ii(d,a,b,c,x[i+15],10,  -30611744);c=ii(c,d,a,b,x[i+ 6],15,-1560198380);b=ii(b,c,d,a,x[i+13],21, 1309151649);
        a=ii(a,b,c,d,x[i+ 4], 6, -145523070);d=ii(d,a,b,c,x[i+11],10,-1120210379);c=ii(c,d,a,b,x[i+ 2],15,  718787259);
        b=ii(b,c,d,a,x[i+ 9],21, -343485551);a=ad(a,olda);b=ad(b,oldb);c=ad(c,oldc);d=ad(d,oldd);
    }
    return rh(a)+rh(b)+rh(c)+rh(d);
}

/////////////////////////////////
////////////// PDP /////////////
///////////////////////////////
let url_vars = ''; 
if(document.location.href.indexOf('?') > -1) {
    url_vars = document.location.href.split('?');
    if(url_vars.length > 1) url_vars = '?' + url_vars[1];
    else url_vars = '';
}

function getVariantId(productColor, size) {
    const options = document.querySelectorAll('#product-select option');
    for (let opt of options) {
        if (
            opt.dataset.option1 === productColor &&
            opt.dataset.option2 === size
        ) {
            let optAttr = {
                val: opt.value,
                available: opt.dataset.available
            };
            return {
                element: opt,
                value: opt.value,
                available: opt.dataset.available,
                price: opt.dataset.price,
                index: opt.dataset.index,
                title: opt.dataset.title,
                option1: opt.dataset.option1,
                option2: opt.dataset.option2,
            };
        }
    }
    return null;
}

const prod_select = document.getElementById('product-select');
const add_button = document.querySelector('.product__buttons .add-button');
const personalize_button = document.querySelector('.product__personalization');
const expected = document.querySelector('.product__expected');
const product_handle = document.querySelector('.product__info-section').getAttribute('data-handle');
prod_select.addEventListener('change', function(e) {
    const variantOption = document.querySelector('.product-option');
    let productSize = variantOption.value;
    let productColor = document.querySelector('.product-option__value').innerHTML.toLowerCase();
    productColor = productColor.replace(' ','-');
    let varientID = getVariantId(productColor, productSize);

    let option = '';
    if(prod_select.options[prod_select.selectedIndex]){
        option = prod_select.options[prod_select.selectedIndex];
    } else {
        option = varientID.element;
    }
    
    let attr = option.getAttribute('data-option1');
    
    if(document.location.href.indexOf('?preview_key=') === -1) window.history.replaceState({}, '', '/products/' + product_handle + '/' + attr + url_vars);

    let activeImages = document.querySelectorAll('.product__image--active');
    for(let i = 0; i < activeImages.length; i++) activeImages[i].classList.remove('product__image--active');

    let media = document.querySelector('.product__media');
    let newImages = [];
    if(media) {
        newImages = media.querySelectorAll('[data-variant=""], [data-variant="' + attr + '"], [data-variant^="' + attr + ',"], [data-variant*=",' + attr + ',"], [data-variant$=",' + attr + '"]');
    }

    setTimeout(function(){
        for(let i = 0; i < newImages.length; i++) newImages[i].classList.add('product__image--active');
        const firstActiveThumb = document.querySelector('.product__image-thumb.product__image--active');
        if(firstActiveThumb) firstActiveThumb.click();
    }, 2);

    let available = option.getAttribute('data-available');
    let incoming = option.getAttribute('data-incoming-date');

    expected.classList.remove('product__expected--active');

    if(incoming) {
        add_button.setAttribute('data-status', 'preorder');
        expected.classList.add('product__expected--active');
        // let date = new Date(incoming);
        expected.innerHTML = incoming;//'Back in stock: ' + date.toDateString();
    } else if(available == 'false') {
        add_button.setAttribute('data-status', 'unavailable');
        personalize_button.setAttribute('data-status', 'unavailable');
    } else {
        add_button.setAttribute('data-status', 'default');
        personalize_button.setAttribute('data-status', 'default');
    }

    let event = new CustomEvent("variant-change", { bubbles: true, detail: attr });
    document.dispatchEvent(event);
});
updateProductOptions();

const prod_options = document.querySelectorAll('select.product-option');
for(let i = 0; i < prod_options.length; i++) prod_options[i].addEventListener('change', function(e) {
    changeProductOption(this);
    updateProductSelect();
});

function changeProductOption(select) {
    const title = select.options[select.selectedIndex].getAttribute('data-title');
    let prod_option = select.closest('.product-option__container');
    if(prod_option) {
        let titleCont = prod_option.querySelector('.product-option__value');
        if(titleCont) titleCont.innerHTML = title;
    }
}
function updateProductOptions() {
    let option1 = document.querySelector('[data-option="1"]');
    let option2 = document.querySelector('[data-option="2"]');
    // let option3 = document.querySelector('[data-option="3"]');

    const prod_select = document.querySelector('.product-select');

    if(option1 && (option2/* || option3*/)) {
        let option_value;
        if(option1.classList.contains('color-swatches')) option_value = option1.querySelector('.color-swatch--active').getAttribute('data-value');
        else option_value = option1.value;

        let options = prod_select.querySelectorAll('option[data-option1="' + option_value + '"]');
        
        let option2List = [];
        // let option3List = [];
        for(let i = 0; i < options.length; i++) {
            if(option2) option2List.push(options[i].getAttribute('data-option2'));
            // if(option3) option3List.push(options[i].getAttribute('data-option3'));
        }

        if(option2) {
            let option2Selected = option2.selectedIndex;
            let hiddenCount = 0;
            for(let i = 0; i < option2.options.length; i++) {
                if(option2List.indexOf(option2.options[i].value) > -1) {
                    option2.options[i].hidden = false;
                    option2.options[i].disabled = false;
                } else {
                    hiddenCount++;
                    option2.options[i].hidden = true;
                    option2.options[i].disabled = true;

                    if(option2Selected == i) changeProductOption(option2);
                }
            }

            if(hiddenCount >= option2.options.length - 1) option2.closest('.product-option__container').classList.add('product-option__container--single-option');
            else option2.closest('.product-option__container').classList.remove('product-option__container--single-option');
        }
    }
}

function updateProductSelect() {
    let option1 = document.querySelector('[data-option="1"]');
    let option2 = document.querySelector('[data-option="2"]');
    let option3 = document.querySelector('[data-option="3"]');

    const prod_select = document.querySelector('.product-select');
    let selector = [];

    if(option1) {
        let option_value;
        if(option1.classList.contains('color-swatches')) option_value = option1.querySelector('.color-swatch--active').getAttribute('data-value');
        else option_value = option1.value;
        selector.push('[data-option1="' + option_value + '"]');
    }

    if(option2) {
        let option_value;
        if(option2.classList.contains('color-swatches')) option_value = option2.querySelector('.color-swatch--active').getAttribute('data-value');
        else option_value = option2.value;
        selector.push('[data-option2="' + option_value + '"]');
    }

    if(option3) {
        let option_value;
        if(option3.classList.contains('color-swatches')) option_value = option3.querySelector('.color-swatch--active').getAttribute('data-value');
        else option_value = option3.value;
        selector.push('[data-option3="' + option_value + '"]');
    }

    let option = prod_select.querySelector('option' + selector.join(''));
    if(!option) {
        option = prod_select.querySelector('option' + selector[0]);
        let select = document.querySelector('.product-option[data-option="2"]');
        select.selectedIndex = 0;
        changeProductOption(select);
    }
    if(option) {
        prod_select.selectedIndex = option.getAttribute('data-index');

        let event = new Event('change');
        prod_select.dispatchEvent(event);
            // ✅ PRICE UPDATE (minimal change)
            const price = option.getAttribute('data-price');
            if (price) {
                const priceEls = document.querySelectorAll('.add-button .product-price');
                priceEls.forEach(el => {
                    el.innerHTML = format_money(parseInt(price, 10));
                });

                console.log('Variant price updated:', price);
            }

            console.log('option', option, 'test');
            }
}

const color_swatches = document.querySelectorAll('.color-swatch');
for(let i = 0; i < color_swatches.length; i++) {
    color_swatches[i].addEventListener('click', function(e) {
        e.preventDefault();
        const cont = this.parentNode;
        const active = cont.querySelectorAll('.color-swatch--active');
        
        const title = this.getAttribute('title');
        let prod_option = this.closest('.product-option__container');
        if(prod_option) {
            let titleCont = prod_option.querySelector('.product-option__value');
            if(titleCont) titleCont.innerHTML = title;
        }

        for(let j = 0; j < active.length; j++) active[j].classList.remove('color-swatch--active');

        this.classList.add('color-swatch--active');

        updateProductOptions();
        updateProductSelect();
    });
}

/////////////////////////////////
//////// MEDIA GALLERY /////////
///////////////////////////////

const thumbs = document.querySelectorAll('.product__image-thumb');
for(let i = 0; i < thumbs.length; i++) {
    thumbs[i].addEventListener('click', function(e) {
        e.preventDefault();
        const index = this.getAttribute('data-index');
        const target = document.querySelector('.product__media-main .product__image[data-index="' + index + '"]');
        if(!target) return;

        const selected = document.querySelectorAll('.product__image--selected');
        for(let j = 0; j < selected.length; j++) selected[j].classList.remove('product__image--selected');

        this.classList.add('product__image--selected');
        target.classList.add('product__image--selected');
    });
}

/////////////////////////////////
///////// ADD TO CART //////////
///////////////////////////////

const pers_container = document.querySelector('.product__personalization');

let product_forms = document.querySelectorAll('.shopify-product-form');
for(let i = 0; i < product_forms.length; i++) {
    product_forms[i].addEventListener('submit', function(e) {
        e.preventDefault();
        const prod_select = this.querySelector('.product-select');
        let variantOption = '';

        if(document.querySelector('.product-option')){
            variantOption = document.querySelector('.product-option');
        }
        let productSize = variantOption.value;
        let productColor = document.querySelector('.product-option__value').innerHTML.toLowerCase();
        productColor = productColor.replace(' ','-');
        let varientID = getVariantId(productColor, productSize);

        let variant_id = '';
        if(prod_select.value != ''){
            variant_id = prod_select.value;
        } else {
            variant_id = varientID.value;
        }
        const quantity = this.querySelector('.product-quantity').value;
        let title = '';
        let selected_option = '';
        if(prod_select.options[prod_select.selectedIndex]){
            selected_option = prod_select.options[prod_select.selectedIndex];
            title = selected_option.getAttribute('data-title');
        } else {
            selected_option = varientID.element;
            title = varientID.title;
        }

        let items = [{
            id: variant_id,
            quantity: quantity,
            properties: {}
        }];

        let optional_section = document.querySelector('.product-info__optional-section--active');
        if(optional_section) {
            let input = optional_section.querySelector('.extra-property');

            items[0].properties[input.getAttribute('data-prop-name')] = input.value;
        }

        if(selected_option.hasAttribute('data-incoming-date')) {
            items[0].properties['Preorder'] = selected_option.getAttribute('data-incoming-date');
        }

        if(pers_container && pers_container.classList.contains('product__personalization--configured')) {
            const pers_id = pers_container.getAttribute('data-id');
            const type = popup.querySelector('[name="properties[Embroidery]"]:checked').value;
            const location = popup.querySelector('[name="properties[Embroidery Location]"]:checked').value;
            const color = popup.querySelector('[name="properties[Embroidery Color]"]:checked').value;
            let text = '';
            const text_values = popup.querySelectorAll('[name="properties[Embroidery Text]"]');
            for(let i = 0; i < text_values.length; i++) {
                text += text_values[i].value;
            }

            let pers_properties = {
                'Embroidery': type,
                'Embroidery Location': location,
                'Embroidery Color': color
            };
            if(type == 'Monogram') pers_properties['Monogram Text'] = text;
            
            let key_gen = Object.assign({}, pers_properties);

            if(optional_section) {
                let input = optional_section.querySelector('.extra-property');
                key_gen[input.getAttribute('data-prop-name')] = input.value;
                title += ' / ' + input.value;
            }
            
            const key = md5(JSON.stringify(key_gen));
            
            pers_properties['For'] = title;
            pers_properties['_parent'] = key;
            items[0].properties['_key'] = key;

            items.push({
                id: pers_id,
                quantity: quantity,
                properties: pers_properties
            });
        }

        let formData = {
            items: items,
            sections: "mini-cart-items"
        };
        
        fetch('/cart/add.js', {
            method: 'POST',
            headers: {
                'Content-Type': 'application/json'
            },
            body: JSON.stringify(formData)
        })
        .then(response => response.json())
        .then(response => {
            // document.querySelector('.mini-cart__items').innerHTML = response.sections['mini-cart-items'];
            location.href = '/cart';
            // document.querySelector('.mini-cart').classList.add('mini-cart--active');
        })
        .catch((error) => {
            console.error('Error:', error);
        });
    });
}

/////////////////////////////////
/////// PERSONALIZATION ////////
///////////////////////////////

const pers_info = document.querySelector('.product__personalization-info');
const pers_popup_activate = document.querySelectorAll('.show-personalization-popup');
const popup = document.querySelector('.popup--personalization');
const price_in_button = document.querySelectorAll('.product__buttons .product-price');

if(popup) {
  const pers_color_swatches = popup.querySelectorAll('.popup--personalization .pers-color-swatch input');
  const pers_color_value = popup.querySelector('.popup--personalization .pers-color-value');
  
  if(pers_popup_activate && popup) for(let i = 0; i < pers_popup_activate.length; i++) pers_popup_activate[i].addEventListener('click', function(e) {
      e.preventDefault();
      document.body.classList.add('popup-active');
      popup.classList.add('popup--active');
  });
  
  if(pers_color_value && pers_color_swatches.length) for(let i = 0; i < pers_color_swatches.length; i++) pers_color_swatches[i].addEventListener('click', function() {
      pers_color_value.innerHTML = this.value;
  });
}

const addButton = document.querySelector('.btn--add-personalization');
if(addButton) addButton.addEventListener('click', function(e) {
    e.preventDefault();
    if(popup) {
        popup.classList.remove('popup--active');
        document.body.classList.remove('popup-active');
    }
    if(pers_container) pers_container.classList.add('product__personalization--configured');
    if(pers_info) {
        const type = popup.querySelector('[name="properties[Embroidery]"]:checked').value;
        const location = popup.querySelector('[name="properties[Embroidery Location]"]:checked').value;
        const color = popup.querySelector('[name="properties[Embroidery Color]"]:checked').value;

        let text = '';
        const text_values = popup.querySelectorAll('[name="properties[Embroidery Text]"]');
        for(let i = 0; i < text_values.length; i++) {
            text += text_values[i].value;
        }

        let value = type;

        if(type == 'Monogram') {
            if(text.trim().length == 0) text = 'N/A';
            value += ': ' + text.toUpperCase();
        }

        value += ', ' + location + ', ' + color;
        pers_info.innerText = value;

        const pers_price = parseInt(pers_container.getAttribute('data-price'));
        for(let i = 0; i < price_in_button.length; i++) {
            let btn_price = parseInt(price_in_button[i].getAttribute('data-price'));
            price_in_button[i].innerHTML = format_money(btn_price + pers_price);
        }
    }
});

document.body.addEventListener('keypress', function(e) {
    let key = e.key || e.keyCode;
    if(( key === 'Enter' || key === 13 ) && document.body.classList.contains('popup-active')) e.preventDefault();
});

const removePersonalization = document.querySelector('.btn--remove-personalization');
if(removePersonalization && pers_container) removePersonalization.addEventListener('click', function(e) {
    e.preventDefault();
    pers_container.classList.remove('product__personalization--configured');

    for(let i = 0; i < price_in_button.length; i++) {
        let btn_price = parseInt(price_in_button[i].getAttribute('data-price'));
        price_in_button[i].innerHTML = format_money(btn_price);
    }
});

const types = document.querySelectorAll('.product__personalization-options--embroidery .product__personalization-option input');
for(let i = 0; i < types.length; i++) types[i].addEventListener('click', function() {
    this.closest('.personalization__container').setAttribute('data-embroidery', this.value);
});

const storeLocatorPopup = document.querySelector('.store-locator__popup');
if(storeLocatorPopup) {
    function distance(lat1, lon1, lat2, lon2) {
        var p = 0.017453292519943295; // Math.PI / 180
        var c = Math.cos;
        var a = 0.5 - c((lat2 - lat1) * p)/2 + c(lat1 * p) * c(lat2 * p) * (1 - c((lon2 - lon1) * p))/2;
      
        return 12742 * Math.asin(Math.sqrt(a)); // 2 * R; R = 6371 km
    }

    const storeLocatorAct = document.querySelector('.store-locator__trigger');
    if(storeLocatorAct) storeLocatorAct.addEventListener('click', function(e) {
        e.preventDefault();
        storeLocatorPopup.classList.remove('store-locator__popup--no-results');
        storeLocatorPopup.classList.add('store-locator__popup--active');
    });

    const storeLocatorOver = document.querySelector('.store-locator__overlay');
    if(storeLocatorOver) storeLocatorOver.addEventListener('click', function(e) {
        e.preventDefault();
        storeLocatorPopup.classList.remove('store-locator__popup--active');
    });

    const storeLocatorClose = document.querySelector('.store-locator__close');
    if(storeLocatorClose) storeLocatorClose.addEventListener('click', function(e) {
        e.preventDefault();
        storeLocatorPopup.classList.remove('store-locator__popup--active');
    });

    let locatorForm = document.querySelector('.store-locator__form');
    if(locatorForm) locatorForm.addEventListener('submit', function(e) {
        e.preventDefault();
        let input = document.querySelector('#store-locator-input').value;

        fetch('https://www.mapquestapi.com/geocoding/v1/address?key=bjzazCCbMai11RQ0ZArYD1YcMw5KMlHG&location='+encodeURIComponent(input))
        .then(response => response.json())
        .then(response => {
            let locations = document.querySelectorAll('.store-location');
            let found = 0;
            for(let i = 0; i < locations.length; i++) {
                if(distance(
                        response.results[0].locations[0].latLng.lat,
                        response.results[0].locations[0].latLng.lng,
                        locations[i].getAttribute('data-lat'),
                        locations[i].getAttribute('data-lng')
                    ) < 160) {
                    found++;
                    locations[i].classList.add('store-location--active');
                } else locations[i].classList.remove('store-location--active');
            }
            if(found == 0) storeLocatorPopup.classList.add('store-locator__popup--no-results');
            else storeLocatorPopup.classList.remove('store-locator__popup--no-results');
        })
        .catch((error) => {
            console.error('Error:', error);
        });
    });
}